import React from 'react'
import { Modal, type ModalProps, useModal } from '@frontend/ui-kit/agromarket/components/Modal'
import { GlassMorphIcon } from '@/components/ui'
import type { GenericErrorModalProps } from './types'

export const GenericErrorModal = Modal.create<GenericErrorModalProps>(({ title, subtitle, button }) => {
  const { remove } = useModal()

  const primaryButton: ModalProps['primaryButton'] = {
    text: button,
    buttonProps: {
      variant: 'primary',
    },
    onClick: remove,
  }

  return <Modal title={title} subtitle={subtitle} primaryButton={primaryButton} icon={<GlassMorphIcon image="red/error" />} />
})
